import { render, staticRenderFns } from "./CustomerProposalHistory.vue?vue&type=template&id=72cbe71a"
import script from "./CustomerProposalHistory.vue?vue&type=script&lang=js"
export * from "./CustomerProposalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports